export default {
    '1b-diagram4': {
        'diagram-task': 'Arrange the points to fit the pyramid structure, then press the Submit button',
        'fixed-answer': 'Brands conveyed knowledge in an information-poor environment.',
        'element_4_1': 'Served as a general indicator of quality',
        'element_4_2': 'Removed the risk from trying new products'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1b/diagram4/i18n/en.js